/* F24 — Home scroll animations + hero word reveal + Hot Sale countdown.
   IntersectionObserver-based. Respects prefers-reduced-motion. Idempotent. */
(function () {
  if (typeof window === 'undefined') return;
  if (window.__F24_HOME_INITED__) return;
  window.__F24_HOME_INITED__ = true;

  document.documentElement.classList.add('f24h-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn){
    if (document.readyState !== 'loading') return fn();
    document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* ---- hero: split headline into animatable words ---- */
    document.querySelectorAll('[data-words]').forEach(function (host) {
      if (host.dataset.split === '1') return;
      host.dataset.split = '1';
      var lines = host.querySelectorAll('.f24h-hero__titleline');
      var idx = 0;
      lines.forEach(function (line) {
        var html = line.innerHTML.split(/(\s+)/).map(function (chunk) {
          if (!chunk.trim()) return chunk;
          return '<span class="f24h-word" style="transition-delay:' + (idx++ * 0.07) + 's">' + chunk + '</span>';
        }).join('');
        line.innerHTML = html;
      });
    });

    /* ---- scroll reveal ---- */
    var revealTargets = [].slice.call(document.querySelectorAll('.f24h-anim, [data-stagger], [data-words]'));
    if (reduce || !('IntersectionObserver' in window)) {
      revealTargets.forEach(function (el) {
        el.classList.add('f24h-anim--in');
        el.querySelectorAll('.f24h-anim').forEach(function (c){ c.classList.add('f24h-anim--in'); });
        el.querySelectorAll('.f24h-word').forEach(function (w){ w.classList.add('in'); });
      });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target;
          el.classList.add('f24h-anim--in');
          if (el.hasAttribute('data-stagger')) {
            var step = parseInt(el.getAttribute('data-stagger') || '90', 10);
            [].slice.call(el.children).forEach(function (child, i) {
              if (!child.classList.contains('f24h-anim')) return;
              setTimeout(function(){ child.classList.add('f24h-anim--in'); }, i * step);
            });
          }
          if (el.hasAttribute('data-words')) {
            el.querySelectorAll('.f24h-word').forEach(function (w){ w.classList.add('in'); });
          }
          io.unobserve(el);
        });
      }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
      revealTargets.forEach(function (el){ io.observe(el); });
    }

    /* ---- Hot Sale countdown ---- */
    var clock = document.querySelector('[data-countdown]');
    if (clock) {
      var target = new Date(clock.getAttribute('data-countdown')).getTime();
      var endStr = clock.getAttribute('data-countdown-end');
      var end = endStr ? new Date(endStr).getTime() : target + 7*864e5;
      var units = {
        d: clock.querySelector('[data-u="d"]'),
        h: clock.querySelector('[data-u="h"]'),
        m: clock.querySelector('[data-u="m"]'),
        s: clock.querySelector('[data-u="s"]')
      };
      function pad(n){ return (n<10?'0':'') + n; }
      function tick() {
        var now = Date.now();
        var live = now >= target && now < end;
        var diff = live ? (end - now) : (target - now);
        if (now >= end) {
          clock.innerHTML = '<div class="f24h-clock__live">Hot Sale finalizado</div>';
          return;
        }
        if (diff < 0) diff = 0;
        var d = Math.floor(diff/864e5);
        var h = Math.floor(diff%864e5/36e5);
        var m = Math.floor(diff%36e5/6e4);
        var s = Math.floor(diff%6e4/1e3);
        if (units.d) units.d.textContent = pad(d);
        if (units.h) units.h.textContent = pad(h);
        if (units.m) units.m.textContent = pad(m);
        if (units.s) units.s.textContent = pad(s);
        var lbl = clock.querySelector('[data-cd-label]');
        if (lbl) lbl.textContent = live ? 'Termina en' : 'Arranca en';
        requestAnimationFrame(function(){ setTimeout(tick, 1000); });
      }
      tick();
    }
  });
})();
